import * as GL from './webgl2constants'
import { GPUAPIObject } from "./GPUAPIObject";
import { arrayBufferView2glType, isInt } from './GPUAPITools';
import {
	InterpolationMode, MipmapInterpolationMode, glInterpMode,
	WrapMode, glWrapMode,
	TexFormat, glTexFormat, texFormatDim
} from './GPUTextureHelper';

// any getTexParameter(enum target, enum pname);
// 		target: TEXTURE_2D, TEXTURE_CUBE_MAP
// 		pname: TEXTURE_BASE_LEVEL, TEXTURE_COMPARE_{ FUNC, MODE }, TEXTURE_IMMUTABLE_{ FORMAT, LEVELS }, TEXTURE_MAX_{ LEVEL, LOD }, TEXTURE_MIN_LOD
// void texParameterf(enum target, enum pname, float param);
// void texParameteri(enum target, enum pname, int param);
// 		pname: TEXTURE_BASE_LEVEL, TEXTURE_COMPARE_{ FUNC, MODE }, TEXTURE_MAX_{ LEVEL, LOD }

// gl.activeTexture(GL.TEXTURE0)
// void generateMipmap(enum target)
// 		target: TEXTURE_{ 2D, 3D, 2D_ARRAY }, TEXTURE_CUBE_MAP


// 		source: pixels of type ImageData, image of type HTMLImageElement, canvas of type HTMLCanvasElement, 
// 		format and type: See format and type for texImage2D
// 		object: See object for texImage2D
// 		target: TEXTURE_{ 2D, 3D, 2D_ARRAY }, TEXTURE_CUBE_MAP_POSITIVE_{ X, Y, Z } TEXTURE_CUBE_MAP_NEGATIVE_{ X, Y, Z }
// 		internalformat: See Tables 3.12, 3.13, 3.14 in the OpenGL ES 3 specification

// https://games.greggman.com/game/opengl-trivia/ this is why we have storage2d/3d : it's for mipmaps. we don't care here.
// void texStorage2D           (enum target, sizei levels, enum internalformat,                sizei width, sizei height)
// void texStorage3D           (enum target, sizei levels, enum internalformat,                sizei width, sizei height, sizei depth)

// void texImage2D             (enum target, int level, enum internalformat,                    long width,  long height,              int border, enum format, enum type, ArrayBufferView ? pixels)
// void texImage2D             (enum target, int level, int internalformat,                    sizei width, sizei height,              int border, enum format, enum type, ArrayBufferView srcData, uint srcOffset)
// void texImage2D             (enum target, int level, int internalformat,                    sizei width, sizei height,              int border, enum format, enum type, TexImageSource source) [throws]
// void texImage2D             (enum target, int level, int internalformat,                    sizei width, sizei height,              int border, enum format, enum type, intptr offset)

// void texImage3D             (enum target, int level, int internalformat,                    sizei width, sizei height, sizei depth, int border, enum format, enum type, ArrayBufferView ? srcData)
// void texImage3D             (enum target, int level, int internalformat,                    sizei width, sizei height, sizei depth, int border, enum format, enum type, ArrayBufferView srcData, uint srcOffset)
// void texImage3D             (enum target, int level, int internalformat,                    sizei width, sizei height, sizei depth, int border, enum format, enum type, TexImageSource source)
// void texImage3D             (enum target, int level, int internalformat,                    sizei width, sizei height, sizei depth, int border, enum format, enum type, intptr offset)

// void texSubImage2D          (enum target, int level, int xoffset, int yoffset,               long width,  long height,                          enum format, enum type, ArrayBufferView ? pixels)
// void texSubImage2D          (enum target, int level, int xoffset, int yoffset,              sizei width, sizei height,                          enum format, enum type, ArrayBufferView srcData, uint srcOffset)
// void texSubImage2D          (enum target, int level, int xoffset, int yoffset,              sizei width, sizei height,                          enum format, enum type, TexImageSource source)
// void texSubImage2D          (enum target, int level, int xoffset, int yoffset,              sizei width, sizei height,                          enum format, enum type, intptr offset)
// void texSubImage3D          (enum target, int level, int xoffset, int yoffset, int zoffset, sizei width, sizei height, sizei depth,             enum format, enum type, ArrayBufferView ? srcData[, uint srcOffset = 0])
// void texSubImage3D          (enum target, int level, int xoffset, int yoffset, int zoffset, sizei width, sizei height, sizei depth,             enum format, enum type, TexImageSource source)
// void texSubImage3D          (enum target, int level, int xoffset, int yoffset, int zoffset, sizei width, sizei height, sizei depth,             enum format, enum type, intptr offset)

// TODO : support this ? current framebuffer to texture
// void copyTexImage2D         (enum target, int level, enum internalformat,      int x, int y, long width, long height, int border)
// void copyTexSubImage2D      (enum target, int level, int xoffset, int yoffset, int x, int y, long width, long height)
// void copyTexSubImage3D      (enum target, int level, int xoffset, int yoffset, int zoffset, int x, int y, sizei width, sizei height)

// TODO : later support them
// void compressedTexImage2D   (enum target, int level, enum internalformat, sizei width, sizei height,              int border, ArrayBufferView srcData[, uint srcOffset = 0[, uint srcLengthOverride = 0]])
// void compressedTexImage3D   (enum target, int level, enum internalformat, sizei width, sizei height, sizei depth, int border, ArrayBufferView srcData[, uint srcOffset = 0[, uint srcLengthOverride = 0]])
// void compressedTexImage2D   (enum target, int level, enum internalformat, sizei width, sizei height,              int border, sizei imageSize, intptr offset)
// void compressedTexImage3D   (enum target, int level, enum internalformat, sizei width, sizei height, sizei depth, int border, sizei imageSize, intptr offset)
// void compressedTexSubImage2D(enum target, int level, int xoffset, int yoffset, sizei width, sizei height, enum format, ArrayBufferView srcData[, uint srcOffset = 0[, uint srcLengthOverride = 0]])
// void compressedTexSubImage2D(enum target, int level, int xoffset, int yoffset, sizei width, sizei height, enum format, sizei imageSize, intptr offset)
// void compressedTexSubImage3D(enum target, int level, int xoffset, int yoffset, int zoffset, sizei level, sizei level, sizei depth, enum format, ArrayBufferView srcData[, uint srcOffset = 0[, uint srcLengthOverride = 0]])
// void compressedTexSubImage3D(enum target, int level, int xoffset, int yoffset, int zoffset, width, sizei height, sizei depth, enum format, sizei imageSize, intptr offset)


// TODO :
// 		fill texture from js array/buffer
// 		fill texture from HTML image/video/canvas
// 		fill texture from GPUBuffer (bind the buffer on PIXEL_UNPACK_BUFFER, then call texSubImage2D(..., offset))

export abstract class GPUTexture extends GPUAPIObject<WebGLTexture> {
	// an alias for this.obj
	get tex() { return this.obj }
	set tex(tex) { this.obj = tex }

	protected abstract get target(): GLenum
	protected abstract get targetBinding(): GLenum

	deleteFunction() { this.gl.deleteTexture(this.obj) }
	createFunction() { return this.gl.createTexture() }
	bind(texUnit?: GLint) {
		// TODO : edge case with TAO
		if(texUnit == undefined) {
			let previousTex = this.gl.getParameter(this.targetBinding)
			this.gl.bindTexture(this.target, this.tex)
			return () => this.gl.bindTexture(this.target, previousTex)
		} else {
			let prevActive = this.gl.getParameter(GL.ACTIVE_TEXTURE)
			this.gl.activeTexture(GL.TEXTURE0 + texUnit)
			let previousTex = this.gl.getParameter(this.targetBinding)
			this.gl.bindTexture(this.target, this.tex)
			return () => {
				this.gl.activeTexture(prevActive)
				this.gl.bindTexture(this.target, previousTex)
			}
		}
	}

	// =============================================
	#interpMag: InterpolationMode = InterpolationMode.nearest
	#interpMin: InterpolationMode = InterpolationMode.nearest
	#interpMagMipmap: MipmapInterpolationMode = MipmapInterpolationMode.none
	#interpMinMipmap: MipmapInterpolationMode = MipmapInterpolationMode.none
	// works only with TEXTURE_2D, TEXTURE_CUBE_MAP
	set interp(mode: InterpolationMode) {
		this.interpMin = mode
		this.interpMag = mode
	}
	set interpMin(mode: InterpolationMode) {
		this.use(() => {
			this.#interpMin = mode
			this.gl.texParameteri(this.target, GL.TEXTURE_MIN_FILTER, glInterpMode(this.#interpMin, this.#interpMinMipmap))
		})
	}
	set interpMag(mode: InterpolationMode) {
		this.use(() => {
			this.#interpMag = mode
			this.gl.texParameteri(this.target, GL.TEXTURE_MAG_FILTER, glInterpMode(this.#interpMag, this.#interpMagMipmap))
		})
	}
	set interpMipmap(mode: MipmapInterpolationMode) {
		this.interpMinMipmap = mode
		this.interpMagMipmap = mode
	}
	set interpMinMipmap(mode: MipmapInterpolationMode) {
		this.use(() => {
			this.#interpMinMipmap = mode
			this.gl.texParameteri(this.target, GL.TEXTURE_MIN_FILTER, glInterpMode(this.#interpMin, this.#interpMinMipmap))
		})
	}
	set interpMagMipmap(mode: MipmapInterpolationMode) {
		this.use(() => {
			this.#interpMagMipmap = mode
			this.gl.texParameteri(this.target, GL.TEXTURE_MAG_FILTER, glInterpMode(this.#interpMag, this.#interpMagMipmap))
		})
	}
	// =============================================
	set wrapR(mode: WrapMode) { this.use( () => this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_R, glWrapMode(mode))) }
	set wrapS(mode: WrapMode) { this.use( () => this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_S, glWrapMode(mode))) }
	set wrapT(mode: WrapMode) { this.use( () => this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_T, glWrapMode(mode))) }
	set wrap(mode: WrapMode) {
		this.use(() => {
			this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_R, glWrapMode(mode))
			this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_S, glWrapMode(mode))
			this.gl.texParameteri(this.target, GL.TEXTURE_WRAP_T, glWrapMode(mode))
		})
	}
	// =============================================

	// ! attention ! we cannot set `this.interp` in constructor because `this.target` is not defined yet
}

































// for now only float textures because https://www.khronos.org/registry/webgl/specs/latest/2.0/ is a mess
export class GPUTexture2D extends GPUTexture {
	get target() { return GL.TEXTURE_2D }
	get targetBinding() { return GL.TEXTURE_BINDING_2D }

	constructor(gl: WebGL2RenderingContext) {
		super(gl)
		this.interp = InterpolationMode.nearest
		this.wrap = WrapMode.repeat
	}

	set(pixels: ArrayBufferView|Array<number>, width: number, height: number, format: TexFormat = TexFormat.rgba, mipmapLevel = 0, regenMipmap = false, offset = 0): this {
		this.use(() => {
			if (pixels instanceof Array) pixels = new Float32Array(pixels)
			let srcType = arrayBufferView2glType(pixels) // TODO : should be overridable
			let [internalFormat,srcFormat] = glTexFormat(format,srcType)
			// this.gl.texImage2D(this.target, mipmapLevel, internalFormat, width, height, 0, srcFormat, srcType, pixels, offset)
			this.gl.texImage2D(this.target, mipmapLevel, internalFormat, width, height, 0, srcFormat, srcType, pixels)
			if (regenMipmap) this.gl.generateMipmap(this.target)
		})
		return this
	}

	// set(pixels: ArrayBufferView, width: number, height: number, format: TexFormat, mipmapLevel = 0, regenMipmap = false, offset = 0) {

	// 	// this.gl.texImage2D(this.target, mipmapLevel, internalFormat, width, height, 0, texFormat2glFormat(format, floatMode), type, pixels, offset)
	// 	this.gl.texImage2D(this.target, mipmapLevel, GL.RGBA32F, width, height, 0, texFormat2glFormat(format, true), GL.FLOAT, pixels, offset)

	// 	// pixels = new Float32Array()
	// 	// let p: Float32Array = pixels
	// 	// console.log(p)

	// 	// void texImage2D(...,ArrayBufferView ? pixels)
	// 	// void texImage2D(...,ArrayBufferView srcData, uint srcOffset)
	// 	// void texImage2D(...,TexImageSource source) [throws]
	// 	// void texImage2D(...,intptr offset)

	// 	// WebGL1:
	// 	// void gl.texImage2D(target, level, internalformat, width, height, border, format, type, pixels: ArrayBufferView)
	// 	// void gl.texImage2D(target, level, internalformat, format, type, pixels: ImageData|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|ImageBitmap)

	// 	// WebGL2:
	// 	// void gl.texImage2D(target, level, internalformat, width, height, border, format, type, GLintptr offset)
	// 	// void gl.texImage2D(target, level, internalformat, width, height, border, format, type, source:HTMLCanvasElement|HTMLImageElement|HTMLVideoElement|ImageBitmap|ImageData)
	// 	// void gl.texImage2D(target, level, internalformat, width, height, border, format, type, ArrayBufferView srcData, srcOffset)

	// }

	// set gpumem(pixels: ArrayBufferView) {
		// let level = 0
		// let internalFormat = "TODO"
		// this.gl.texImage2D(this.target,level,internalFormat,w,h,0,format,type,pixels)
		// TODO
	// }
}

// export class GPUTexture3D extends GPUTexture { get target() { return GL.TEXTURE_3D } get targetBinding() { return GL.TEXTURE_BINDING_3D } }
// export class GPUTexture2DArray extends GPUTexture { get target() { return GL.TEXTURE_2D_ARRAY } get targetBinding() { return GL.TEXTURE_BINDING_2D_ARRAY } }

// export class GPUTextureCubeMap extends GPUTexture {
// 	get target() { return GL.TEXTURE_CUBE_MAP }
// 	get targetBinding() { return GL.TEXTURE_BINDING_CUBE_MAP }
// 	set(face: "+x" | "+y" | "+z" | "-x" | "-y" | "-z", pixels: ArrayBufferView, width: number, height: number, colorDim: 1 | 2 | 3 | 4, mipmapLevel = 0, regenMipmap = false, offset = 0) {}
// }


export class GPUTexture1D extends GPUTexture {
	get target() { return GL.TEXTURE_2D }
	get targetBinding() { return GL.TEXTURE_BINDING_2D }

	constructor(gl: WebGL2RenderingContext) {
		super(gl)
		this.interp = InterpolationMode.nearest
		this.wrap = WrapMode.repeat
	}

	set(pixels: ArrayBufferView | Array<number>, format: TexFormat = TexFormat.rgba, mipmapLevel = 0, regenMipmap = false, offset = 0): this {
		if (pixels instanceof DataView) throw `DataView not supported yet`
		let len = (pixels as any).length / texFormatDim(format)
		let width = Math.min(this.gl.getParameter(GL.MAX_TEXTURE_SIZE), len) as number
		let height = Math.ceil(len / width)

		this.use(() => {
			if (pixels instanceof Array) pixels = new Float32Array(pixels)
			let srcType = arrayBufferView2glType(pixels) // TODO : should be overridable
			let [internalFormat, srcFormat] = glTexFormat(format, srcType)
			this.gl.texImage2D(this.target, mipmapLevel, internalFormat, width as number, height as number, 0, srcFormat, srcType, pixels)
			if (regenMipmap) this.gl.generateMipmap(this.target)
		})
		return this
	}
}
